import { render, staticRenderFns } from "./resume-block.vue?vue&type=template&id=7ca7f8ac&scoped=true"
import script from "./resume-block.vue?vue&type=script&lang=js"
export * from "./resume-block.vue?vue&type=script&lang=js"
import style0 from "./resume-block.vue?vue&type=style&index=0&id=7ca7f8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca7f8ac",
  null
  
)

export default component.exports